var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 753.29 763.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-hair-1 {\n        fill: var(--custom-color, #1a1a1a) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M54.32,690.12c-6.74,1.58-13.76,2.43-20.99,2.43-11.76,0-23.01-2.22-33.33-6.27v29.01c0,26.52,21.5,48.02,48.02,48.02h74.49c-27.17-19.74-50.37-44.6-68.19-73.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M15.06,511.62v-38.38c0-92.75,34.99-177.32,92.48-241.25-2,10.67-3.06,21.67-3.06,32.92h0c0,45.56,36.93,82.49,82.49,82.49h376.85c45.56,0,82.49-36.93,82.49-82.49h0c0-11.85-1.17-23.42-3.39-34.62,58.4,64.13,94.01,149.38,94.01,242.95v38.38c5.66,1.15,11.12,2.84,16.35,4.98v-249.31h0v-2.73c0-.92-.04-1.83-.07-2.74C750.31,116.73,631.79,0,486,0h-218.7C121.5,0,2.98,116.73.07,261.82c-.03.91-.07,1.82-.07,2.74v2.73h0v248.77c4.83-1.89,9.87-3.39,15.06-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M718.67,692.55c-7.22,0-14.25-.84-20.99-2.43-17.82,28.57-41.02,53.44-68.19,73.18h75.78c26.52,0,48.02-21.5,48.02-48.02v-29.53c-10.68,4.38-22.37,6.8-34.63,6.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair3);
export default __webpack_public_path__ + "static/media/hair3.0959263c94907bc6a6f84e75ceb1b72d.svg";
export { ForwardRef as ReactComponent };